import { AdditionalInformationFormFragment } from 'generated/resources/graphql'

export const getAdditionalInformationAttributes = (data: AdditionalInformationFormFragment) => {
  return {
    internalReference: data.internalReference,
    description: data.description,
  }
}
